import React, {useContext} from "react";
import {StateContext} from "../Contexts";
import {getCurrentPlan} from "../Billwerk/SubscriptionJS";
import OnOffComponent from "./OnOffComponent";
import Line from "@erecht24/frontend-kit/theme/components/misc/Line";
import getWithComponentsArray from "../Util/getWithComponentsArray";
import getHideComponentsArray from "../Util/getHideComponentsArray";

export default function (props) {
    /** @type CheckoutState */
    const state = useContext(StateContext);

    if (state.mainProps.hideOnOffComponents) {
        return null;
    }

    let plan = getCurrentPlan(state);
    let withComponents = getWithComponentsArray(state);
    let hideComponents = getHideComponentsArray(state);

    if (!plan?.components || plan?.components.length < 1) {
        return null;
    }

    const isComponentActive = (component) => {
        return state.cart.components[component.external_id]?.quantity > 0;
    }

    let withComponentsComponents = [...Object.values(plan?.components)].filter(function (component) {
        /** @var component App_Http_Resources_Component */
        if (withComponents.length < 1 || !withComponents.includes(component.external_id))
            return false;

        if (hideComponents.length > 0 && hideComponents.includes(component.external_id))
            return false;

        return true;
    })

    let components = [...Object.values(plan?.components)].filter(function (component) {
        /** @var component App_Http_Resources_Component */
        if (withComponents.length > 0 && withComponents.includes(component.external_id))
            return false;

        if (hideComponents.length > 0 && hideComponents.includes(component.external_id))
            return false;

        return component.component_type === 'OnOff' && (component.plan_components?.mode !== 'inclusive' || withComponents.includes(component.external_id));
    });

    let includedComponents = [...Object.values(plan?.components)].filter(function (component) {
        /** @var component App_Http_Resources_Component */
        if (withComponents.length > 0 && withComponents.includes(component.external_id))
            return false;

        if (hideComponents.length > 0 && hideComponents.includes(component.external_id))
            return false;

        if (['black-weekend-power-booster', 'cyberweek-power-booster'].includes(component.external_id)) {
            return false;
        }

        return component.component_type === 'OnOff' && component.plan_components?.mode === 'inclusive' && component.plan_components?.quantity > 0;
    });


    if (withComponentsComponents.length < 1 && components.length < 1 && includedComponents.length < 1) {
        return null;
    }

    return <>
        {withComponentsComponents.length > 0 &&
            <div className="flex flex-col gap-10">
                {withComponentsComponents.map(function (component) {
                    /** @var component App_Http_Resources_Component */
                    return <OnOffComponent component={component}></OnOffComponent>
                })}
            </div>
        }
        {components.length > 0 &&
            <>
                {(props.withLine || withComponentsComponents.length > 0) &&
                    <Line className="hidden lg:block"></Line>
                }
                <h3 className="h3 hidden lg:block">Runden Sie Ihren Tarif ab</h3>
                <div className="flex flex-col gap-10">
                    {components.map(function (component) {
                        /** @var component App_Http_Resources_Component */
                        return <OnOffComponent component={component} active={isComponentActive(component)}></OnOffComponent>
                    })}
                </div>
            </>
        }
        {includedComponents.length > 0 &&
            <>
                {components.length > 0 &&
                    <Line className="hidden lg:block"></Line>
                }
                <div className="flex flex-col gap-10">
                    {includedComponents.map(function (component) {
                        /** @var component App_Http_Resources_Component */
                        return <OnOffComponent component={component}></OnOffComponent>
                    })}
                </div>
            </>
        }
    </>
}
